/** Pure model-output policy shared by catalog discovery and every chat picker.
 * Unknown output metadata remains selectable; explicitly empty or non-text outputs do not.
 * The web build-root projection is byte-pinned by webMirrorContracts.test.ts. */

export function modelSupportsOutput(model: { outputs?: readonly string[] }, output: string): boolean {
  return model.outputs === undefined || model.outputs.includes(output);
}

export function chatModelCatalog<T extends { kind?: 'image'; outputs?: readonly string[] }>(models: readonly T[]): T[] {
  return models.filter((model) => model.kind !== 'image' && modelSupportsOutput(model, 'text'));
}
